import React from 'react';
import type { Helix2000Character } from '../../../../shared/CharacterTypes';
import { CharacterPortrait } from '../../components/CharacterPortrait';
import { formatCallingName } from '../../theme';

/** Never use a class preset to guess another player's missing appearance. */
export function SocialIdentity({ actor, name, level, size = 52 }: {
  actor?: Helix2000Character | null; name: string; level?: number; size?: number;
}): React.ReactElement {
  const portraitReady = actor?.appearance != null && actor.equipmentVisuals != null;
  return <div className="social-identity">
    {portraitReady ? <CharacterPortrait appearance={actor.appearance} characterClass={actor.class}
      equipmentVisuals={actor.equipmentVisuals!} size={size} label={`${name}, current appearance and equipped gear`} />
      : <span className="social-identity__monogram" style={{ width: size, height: size }} aria-label={`${name}, portrait unavailable`}>{name.trim().slice(0, 1).toUpperCase() || '?'}</span>}
    <div><strong>{name}</strong><span>{typeof level === 'number' && Number.isFinite(level) ? `Level ${level}` : 'Level unavailable'}
      {actor?.class ? ` · ${formatCallingName(actor.class)}` : ''}</span></div>
  </div>;
}
